import React from 'react'
import Chip from '@mui/material/Chip'
import Link from '@mui/material/Link'
import { hashHistory } from 'react-router'
import { policyPath, policyStatusMeta } from '../../lib/collections.es6'

/**
 * A policy number that opens the policy page, optionally with its status. Used in tables, so a click here
 * must not also open the row behind it.
 */
export function PolicyLink({ policyNumber, fallback, status }) {
  const path = policyPath(policyNumber)
  const meta = status ? policyStatusMeta(status) : null
  return (
    <span>
      {path ? (
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={e => {
            e.stopPropagation()
            hashHistory.push(path)
          }}
          sx={{ verticalAlign: 'baseline' }}
        >
          {policyNumber}
        </Link>
      ) : (
        fallback || '-'
      )}
      {meta ? (
        <Chip
          size="small"
          label={meta.label}
          color={meta.color}
          variant={meta.color === 'default' ? 'outlined' : 'filled'}
          sx={{ ml: 1 }}
        />
      ) : null}
    </span>
  )
}

export default PolicyLink
